// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k08UpPKQpaEcKrX92H9t{flex-direction:column;gap:18px;display:flex}.nf2Eq0cGQK8JSkzpGTqM{flex-direction:column;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `k08UpPKQpaEcKrX92H9t`,
	"section": `nf2Eq0cGQK8JSkzpGTqM`
};
export default ___CSS_LOADER_EXPORT___;
